import React from 'react';
import { Chip, Tooltip, Link, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import DeviceIconComponent from '#component/icon/device-icon';

const StyledChip = styled(Chip)(() => ({
  margin: '4px 2px',
  border: 0,
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      cursor: 'pointer',
      color: '#878787'
    }
  }
}));

const DeleteIconContainer = styled(IconButton)(() => ({
  margin: 0
}));

const ChipDeleteIconStyled = styled(CloseIcon)(() => ({
  color: '#0000008a'
}));

export const DeviceChip = ({
  device,
  meta,
  handleRemoveDevice,
  onAlertChange,
  disabled
}) => {
  const chipTooltip = 'Open the device in a new tab';

  const notificationProps = {
    fontSize: 'small',
    onClick: e => {
      onAlertChange?.(e, device);
    },
    onMouseDown: e => {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <div>
      <StyledChip
        tabIndex={-1}
        key={`${device.id} + ${device.projectId || 1}`}
        variant="outlined"
        disabled={disabled}
        label={(
          <>
            {device.label || device.title || device.uid}
            {
              device.showAlertIcon ?
                <Tooltip title={device.alertLabel || 'Does not have an alert'}>
                  {device.alertOn ?
                    <IconButton size="small"><NotificationsActiveRoundedIcon {...notificationProps} /></IconButton> :
                    <IconButton size="small"><NotificationsOffOutlinedIcon {...notificationProps} /></IconButton>}
                </Tooltip> :
                null
            }
            <Tooltip title={chipTooltip}>
              <Link
                href={`${window.location.origin}/device/${device.id}`}
                color="inherit"
                target="_blank"
                onMouseDown={e => e.stopPropagation()}
              >
                <IconButton onClick={e => e.stopPropagation()} size="small">
                  <LaunchIcon
                    fontSize="small"
                    color="action"
                  />
                </IconButton>
              </Link>
            </Tooltip>
          </>
        )}
        icon={<DeviceIconComponent
          icon={meta.device?.find(m => m.name === device.type)?.icon}
        />}
        style={{ color: 'inherit' }}
        onDelete={e => {
          e?.stopPropagation();
          handleRemoveDevice(device);
        }}
        deleteIcon={
          <DeleteIconContainer
            size="small"
            aria-label="Remove device button"
            onClick={e => {
              e.stopPropagation();
              handleRemoveDevice(device);
            }}
          >
            <ChipDeleteIconStyled
              fontSize="small"
            />
          </DeleteIconContainer>
        }
      />
    </div>
  );
};
